<template>
    <div>
        <div class="row">
            <div class="col-12">
                <g-table-sync ref="billsTable" :app="app" :view="view" :columns="columns" :default-limit="20"
                    :required-filters="tableFilters" pagination="loadmore" @edit="openForm">
                    <template slot="total" slot-scope="{ item }">
                        <span v-if="item.total"> {{ item.total | price }} € </span>
                    </template>

                    <template slot="client_name" slot-scope="{ item }">
                        <truncate tag="span" class="clickable"
                            @click="$router.push(`/client/${item.client._EntityId}`)">
                            {{ item.client_name }}
                        </truncate>
                    </template>

                    <template slot="date" slot-scope="{ item }">
                        <span>{{ item.date }}</span>
                    </template>

                    <template slot="status" slot-scope="{ item }">
                        <g-select :item="item._EntityId" :app="app" name="status"
                            :colors="[$colors.blue, $colors.orange, $colors.success, '#ff0000']" block />
                    </template>

                    <template slot="download" slot-scope="{ item }">
                        <a-button-group v-if="item.pdf">
                            <a-tooltip v-if="!isNative">
                                <template #title>Imprimir</template>
                                <a-button type="primary" :disabled="printing === item._EntityId"
                                    @click="printBill(item)">
                                    <fa-icon :icon="['fas', 'print']" />
                                </a-button>
                            </a-tooltip>

                            <a-tooltip>
                                <template #title>Ver</template>
                                <a-button type="primary" :disabled="printing === item._EntityId"
                                    @click="openBill(item)">
                                    <fa-icon :icon="['fas', 'eye']" />
                                </a-button>
                            </a-tooltip>

                            <a-tooltip placement="top">
                                <template slot="title">
                                    <span v-if="printing === item._EntityId">Generando factura</span>
                                    <span v-else>Regenerar</span>
                                </template>
                                <a-button :disabled="printing === item._EntityId" @click="generatePdfBill(item, true)">
                                    <fa-icon :icon="['fas', 'sync-alt']" :spin="printing === item._EntityId" />
                                </a-button>
                            </a-tooltip>
                        </a-button-group>
                        <a-button v-else :loading="printing === item._EntityId" :disabled="printing === item._EntityId"
                            @click="generatePdfBill(item, true)" block>
                            <fa-icon v-if="!printing || printing !== item._EntityId" :icon="['far', 'file-pdf']"
                                class="mr-2" />
                            Generar
                        </a-button>
                    </template>

                    <template slot="head-right" slot-scope="data">
                        <a-tooltip placement="top" v-show="data.select.length">
                            <template slot="title"> Cambiar estado a {{ data.select.length }} facturas</template>
                            <g-select :item="data.select" app="bills" name="status"
                                :colors="[$colors.blue, $colors.orange, $colors.success]" placeholder="Estado"
                                :style="{ padding: '5px 10px' }" :notify="true" />
                        </a-tooltip>

                       

                        <!-- Descargar facturas electronicas -->
                        <!-- <a-tooltip placement="top">
                            <template slot="title">
                                {{
                                    data.select.length === 0
                                        ? 'No se han seleccionado facturas'
                                        : `Descargar ${data.select.length} facturas electrónicas`
                                }}
                            </template>
                            <a-button
                                v-show="data.select.length"
                                class="mr-2"
                                :loading="converting"
                                @click="getfacturae(data.select)"
                            >
                                <fa-icon v-show="!xport.loading" class="mr-2" :icon="['fas', 'download']" /> Zip
                            </a-button>
                        </a-tooltip> -->
                        <!-- Descargar zip con los pdf de varias facturas -->
                        <a-tooltip placement="top">
                            <template slot="title">
                                {{
                                        data.select.length === 0
                                            ? 'No se han seleccionado facturas'
                                            : `Descargar ${data.select.length} facturas PDF`
                                }}
                            </template>
                            <a-button v-show="data.select.length" class="mr-2" :loading="converting"
                                @click="downloadBillsZip(data.select)">
                                <fa-icon v-show="!xport.loading" class="mr-2" :icon="['fas', 'download']" /> Zip
                            </a-button>
                        </a-tooltip>

                         <!-- Cargar en SERES -->
                        <a-tooltip placement="top">
                            <template slot="title">
                                {{
                                        data.select.length === 0
                                            ? 'No se han seleccionado facturas'
                                            : `Enviar a SERES ${data.select.length} facturas`
                                }}
                            </template>
                            <a-button v-show="data.select.length" class="mr-2 py-1 px-2" :loading="converting"
                                @click="facturaeToSERES(data.select)">
                                <!-- <fa-icon v-show="!xport.loading" class="mr-2" :icon="['fas', 'file-export']" /> SERES -->
                                <img :src="require('@/application/assets/images/seres.webp')" class="mh-100" />
                            </a-button>
                        </a-tooltip>
                    </template>
                    <template slot="actions" slot-scope="{ item }">
                        <div class="text-right">
                            <a-button-group>
                                <!-- Editar -->
                                <a-tooltip v-if="
                                    $gestios.items(app).auth({
                                        scopes: [`set.mine`, `set`],
                                        strict: false,
                                        item,
                                    })
                                ">
                                    <template slot="title">
                                        <fa-icon :icon="['far', 'edit']" class="mr-2" /> Editar
                                    </template>

                                    <a-button @click="
                                        $router.push({
                                            name: 'billsEdit',
                                            params: { id: item._EntityId },
                                        })
                                    ">
                                        <fa-icon :icon="['far', 'edit']" />
                                    </a-button>
                                </a-tooltip>

                                <!-- Enviar email -->
                                <a-tooltip>
                                    <template slot="title">
                                        <fa-icon :icon="['far', 'envelope']" class="mr-2" /> Enviar por email
                                    </template>

                                    <a-button :disabled="!item.pdf" @click="mailerScope = item">
                                        <fa-icon :icon="['far', 'envelope']" />
                                    </a-button>
                                </a-tooltip>

                                <!-- Borrar -->
                                <a-popconfirm v-if="
                                    $gestios.items(app).auth({
                                        scopes: [`del.mine`, `del`],
                                        strict: false,
                                        item,
                                    })
                                " title="¿Estas seguro que deseas borrar esta factura?"
                                    @confirm="() => deleteBill(item._EntityId)">
                                    <a-tooltip placement="top">
                                        <template slot="title">
                                            <span>
                                                <fa-icon :icon="['far', 'trash-alt']" class="mr-2" /> Eliminar
                                            </span>
                                        </template>
                                        <a-button type="danger">
                                            <fa-icon :icon="['far', 'trash-alt']" />
                                        </a-button>
                                    </a-tooltip>
                                </a-popconfirm>
                            </a-button-group>
                        </div>
                    </template>
                </g-table-sync>
            </div>
        </div>
        <mailer :item="mailerScope" :view="view" file-prop-name="pdf" @close="mailerScope = null" />
    </div>
</template>

<script>
import printJS from 'print-js'
import { required } from 'vee-validate/dist/rules'
// import concepts from '../../mixins/concepts'
import mailer from '../../components/mailer'
import billsMX from './mixins/bill'

export default {
    name: 'Bills',
    components: { mailer },
    mixins: [billsMX],
    data() {
        return {
            app: 'bills',
            view: 'billList',
            mailerScope: null,
            printing: false,
            converting: false,
            xport: {
                loading: false,
            },
            datesFilter: {
                enabled: false,
                loading: false,
                dates: [],
            },
            columns: [
                // {
                //     title: 'ID',
                //     index: '_EntityId',
                //     order: true,
                //     search: true
                // },
                {
                    title: 'Nº',
                    index: 'serie',
                    order: true,
                    search: true,
                },
                {
                    title: 'Empresa',
                    index: 'client_name',
                    order: false,
                    search: true,
                    slot: 'client_name',
                },
                {
                    title: 'Importe',
                    index: 'total',
                    order: true,
                    slot: 'total',
                },
                {
                    title: 'Fecha',
                    index: 'date',
                    order: true,
                    slot: '_date',
                    search: false,
                    date: true,
                },
                {
                    title: 'Email',
                    index: 'email',
                    slot: '_email',
                },
                {
                    title: 'Descargar',
                    width: '160px',
                    slot: 'download',
                },
                {
                    title: 'Estado',
                    index: 'status',
                    slot: 'status',
                    order: true,
                },
                {
                    title: 'eFactura',
                    index: 'efactura_date',
                    order: true,
                    slot: '_date',
                    search: false,
                    date: true,
                },
                {
                    title: 'Acciones',
                    width: '190px',
                    slot: 'actions',
                },
            ],
        }
    },
    computed: {
        tableFilters() {
            return [...this.routeFilter]
        },
        routeFilter() {
            if (this.$route?.query?.field && this.$route?.query?.value) {
                return [
                    {
                        _ParentOperator: 'AND',
                        _Operator: 'AND',
                        Fields: {
                            [this.$route.query.field]: {
                                type: 3,
                                int: parseInt(this.$route.query.value, 10),
                                opt: '=',
                            },
                        },
                    },
                ]
            }
            return []
        },
        isNative() {
            if (window.cordova) return true
            return false
        },
    },
    created() {
        this.$hub.$on('newBill', () => {
            this.$router.push({ name: 'billsNew' })
        })
    },
    beforeDestroy() {
        this.$hub.$off('newBill')
    },
    methods: {
        openForm(item) {
            this.$router.push({ name: 'billsEdit', params: { id: item._EntityId } })
        },
        printBill(bill) {
            if (bill.pdf) {
                if (window.cordova) {
                    window.open(bill.pdf.Link, '_system')
                } else {
                    printJS(bill.pdf.Link)
                }
            }
        },
        openBill(bill) {
            if (bill.pdf) {
                window.open(bill.pdf.Link, this.isNative ? '_system' : '_blank')
            }
        },
        async exportData() {
            if (this.$gestios.auth.check({ scopes: ['_BOSS'] })) {
                this.xport.loading = true

                const params = {
                    from: this.xport.dates[0].format('YYYY-MM-DD'),
                    to: this.xport.dates[1].format('YYYY-MM-DD'),
                }

                try {
                    const response = await this.$lambda.get(`bills/excel?from=${params.from}&to=${params.to}`, {
                        responseType: 'blob',
                    })

                    this.$message.success('Exportación finalizada. Descargando fichero...')

                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute(
                        'download',
                        `Partes de ${this.xport.dates[0].format('LL')} a ${this.xport.dates[1].format('LL')}.xlsx`
                    )
                    document.body.appendChild(link)
                    link.click()
                    link.parentNode.removeChild(link)
                } catch (err) {
                    this.$message.error('Ocurrió un error en la exportacion de los partes')
                }

                this.xport.enabled = false
                this.xport.loading = false
            }
        },
        async facturaeToSERES(selected) {
            this.converting = true
            const identifiers = selected.map((item) => item._EntityId)
            try {
                const res = await this.$lambda.get(`bills/edi?upload_to_seres=true&identifiers=${identifiers}`, {
                    responseType: 'blob',
                })
                if (res.ok) {
                    this.$message.success('Generacion finalizada')
                } else {
                    this.$message.error('No se pudo completar la operación')
                    throw String('No se pudo completar la operación')
                }
            } catch (err) {
                console.error(err)
                this.converting = false
                this.$message.error('Ocurrió un error en la exportacion de los partes')
            } finally {
                this.converting = false
            }
        },
        async getfacturae(selected) {
            this.converting = true
            const identifiers = selected.map((item) => item._EntityId)

            try {
                const res = await this.$lambda.get(`bills/edi?to_zip=true&identifiers=${identifiers}`, {
                    responseType: 'blob',
                })

                if (res.ok) {
                    const downloadUrl = window.URL.createObjectURL(res.data)
                    const a = document.createElement('a')
                    a.href = downloadUrl
                    a.download = 'facturaE.zip'
                    document.body.appendChild(a)
                    a.click()
                    URL.revokeObjectURL(downloadUrl)

                    identifiers.forEach((id) => {
                        this.$gestios.$cache
                            .items('bills')
                            .edit({ id, params: { efactura_date: this.$moment().format('YYYY-MM-DD HH:mm:ss') } })
                    })

                    this.$message.success('Exportación finalizada. Descargando fichero...')
                } else {
                    this.$message.error('No se pudo completar la operación')
                    throw String('No se pudo completar la operación')
                }
            } catch (err) {
                console.error(err)
                this.converting = false
                this.$message.error('Ocurrió un error en la exportacion de los partes')
            } finally {
                this.converting = false
            }
        },
        async downloadBillsZip(selected) {
            this.converting = true

            try {
                // Primero miramos si alguna no tiene creado el pdf y lo pedimos
                let pendingToGeneratePdf = selected.reduce((acc, bill) => {
                    if (!bill.pdf || !bill.pdf.Link) acc.push(bill)
                    return acc
                }, [])

                if (pendingToGeneratePdf.length) {
                    this.$gestios.$toast.info("Generando facturas")
                }

                let pendingPdfGenerated = 0
                await Promise.all(
                    pendingToGeneratePdf.map(async bill => {
                        const res = await this.generatePdfBill(bill, false)
                        if (res) {
                            pendingPdfGenerated += 1
                            this.$gestios.$toast.success(
                                `${pendingPdfGenerated} de ${pendingToGeneratePdf.length} pdfs, generados`
                            )
                        }
                    })
                )
            } catch (err) {
                this.$gestios.$toast.error("Algo salio mal al generar las facturas")
            } finally {
                this.converting = false
            }


            // Generados todos los pds restantes llamamos a la api para generar el zip
            try {
                const identifiers = selected.map((item) => item._EntityId)
                const res = await this.$lambda(`bills/toZip?identifiers=${identifiers}`, {
                    responseType: 'blob',
                })

                if (!res.ok) throw 'no se pudo descargar el pdf'

                // Si todo ha salido bien se descarga el zip con las facturas
                this.$message.success('Exportación finalizada. Descargando fichero...')
                const downloadUrl = window.URL.createObjectURL(res.data)
                const a = document.createElement('a')
                a.href = downloadUrl
                a.download = 'facturas_pdf.zip'
                document.body.appendChild(a)
                a.click()
                URL.revokeObjectURL(downloadUrl)

            } catch (err) {
                console.log(err)
                this.$gestios.$toast.error("Algo salio mal durante la creacion del pdf")
            } finally {
                this.converting = false
            }

        },
        async deleteBill(id) {
            const res = await this.$gestios.items('bills').delete({
                id: parseInt(id, 10),
            })

            if (res.ok) this.$gestios.$message.success('Factura borrada correctamente 😄')
            else this.$gestios.$message.error('No se pudo borrar la factura')
        },
    },
}
</script>

<style lang="scss">
.clickable {
    cursor: pointer;
}
</style>
